import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ThreeCircles } from "react-loader-spinner";
import './button.css'

/**
 * @param {{ progress?: boolean, onclick: (e: any) => void, content: string, disable?: boolean, icon?: React.ReactNode }} props
 */
export const CustomButton = ({ progress, onclick, content, disable = false, icon = null }) => {
    const [apiProgress, setApiProgress] = useState(progress)
    const [buttonContent, setButtonContent] = useState(content)
    const [isDisabledFlag, setIsDisabledFlag] = useState(disable)
    useEffect(() => {
        setApiProgress(progress !== undefined ? progress : false)
    }, [progress])

    useEffect(() => {
        setButtonContent(content)
    }, [content])

    useEffect(() => {
        setIsDisabledFlag(disable)
    }, [disable])

    return (
        <div style={{ width: "fit-content" }}>
            <Button
                type="submit"
                onClick={(e) => onclick(e)}
                className={!apiProgress ? "custom-button" : "custom-button-api-progress"}
                disabled={isDisabledFlag}
                style={{ margin: "0px 5px" }} // This is just to make sure tht is there are multiple aligning buttons there is proper spacing between them.
            >
                {
                    !apiProgress ?
                        <>
                            {icon && <span style={{ marginRight: "5px" }}>{icon}</span>}
                            {buttonContent}
                        </>
                        :
                        <>
                            {buttonContent} &nbsp;
                            <ThreeCircles
                                height="15"
                                width="15"
                                color="#4fa94d"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel="three-circles-rotating"
                                outerCircleColor="var(--theme1_primary)"
                                innerCircleColor="var(--theme1_secondary)"
                                middleCircleColor="var(--theme1_tertiary)"
                            />
                        </>
                }
            </Button>
        </div>
    );
};
